import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import { ProductCard } from '../components/ProductCard';
import { PRODUCTS_CONFIG, COMPANY_CONFIG } from '../config/site';

export function ProductsPage() {
  return (
    <>
      <SEOHead
        title="SaaS Products &amp; Software Platforms | Safaza Technologies, Inc."
        description="Discover software products developed and operated by Safaza Technologies, Inc., including the Akoole inventory and business management platform."
      />

      {/* Header Banner */}
      <section className="pt-16 pb-16 sm:pt-24 sm:pb-20 bg-white border-b border-[#E4E7EC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0D66E4]/8 border border-[#0D66E4]/20 text-[11px] font-mono font-medium text-[#0D66E4] mb-4">
              <span>SOFTWARE PRODUCT PORTFOLIO</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#101828] mb-6">
              Practical SaaS products built for daily operations
              <span className="text-[#0D66E4]">.</span>
            </h1>
            <p className="text-lg text-[#667085] leading-relaxed">
              We design, build, and operate software products that solve real operational friction.
              Our portfolio includes commercial SaaS platforms and modular cloud frameworks engineered
              for reliability and growth.
            </p>
          </div>
        </div>
      </section>

      {/* Portfolio Status Disclosure Box */}
      <section className="py-8 bg-[#F6F8FB] border-b border-[#E4E7EC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="p-4 sm:p-5 rounded-xl bg-white border border-[#E4E7EC] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs">
            <div className="flex items-center gap-3">
              <span className="px-2.5 py-0.5 rounded-full bg-[#0D66E4]/10 text-[#0D66E4] font-semibold text-[11px] shrink-0">
                Portfolio Status
              </span>
              <p className="text-[#475467]">
                <strong>Active Deployment:</strong> Safaza Technologies, Inc. develops and maintains the Akoole business management platform (available in commercial operation), alongside modular cloud systems in active development.
              </p>
            </div>
            <Link
              to="/contact?type=SaaS%20%26%20product%20inquiry"
              className="text-[#0D66E4] font-semibold hover:underline shrink-0"
            >
              Inquire about our products &rarr;
            </Link>
          </div>
        </div>
      </section>

      {/* Products Portfolio Grid */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {PRODUCTS_CONFIG.map((product) => (
              <ProductCard key={product.id} product={product} compact={false} />
            ))}
          </div>

          {/* Verification / Partnership Banner */}
          <div className="mt-20 p-8 sm:p-10 rounded-2xl bg-[#F6F8FB] border border-[#E4E7EC]">
            <div className="max-w-2xl">
              <h3 className="text-xl font-bold text-[#101828] mb-2">
                Commercial Partnerships &amp; Integration Opportunities
              </h3>
              <p className="text-sm text-[#667085] leading-relaxed mb-6">
                Are you an enterprise customer, technology provider, or commercial partner interested
                in collaborating on product architecture, pilot programs, or API integrations with{' '}
                {COMPANY_CONFIG.legalName}?
              </p>
              <Link
                to="/contact?type=Partnership%20inquiry"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white bg-[#101828] hover:bg-[#0D66E4] rounded-full transition-colors"
              >
                <span>Initiate partnership discussion</span>
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

